import { MatBadgeModule } from '@angular/material/badge';
import { UnreadMessagesService } from '../../domain/service/unreadMessages.service';
import { Component, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import {MatMenu, MatMenuModule} from "@angular/material/menu";
import {MatBadge} from "@angular/material/badge";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.css',
  standalone: true,
  imports: [
    MatBadgeModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    AsyncPipe,
    MatMenu,
    MatBadge,
    RouterLink,
    MatMenuModule,
    RouterLinkActive,
  ]
})
export class SideMenuComponent {
  constructor(public unread: UnreadMessagesService) { this.unread.refresh(); }
  pendingActionsCount: 13 | undefined;
}
